import GenericError from "@components/errors/GenericError";
import { Route, Routes } from "react-router-dom";
import Analytics from "src/modules/Analytics/Analytics";
import Login from "src/modules/authentication/login";
import VerifyOtp from "src/modules/authentication/VerifyOtp";
import DownloadReport from "src/modules/Prime/DownloadReport";
import CrossRampRates from "src/modules/Prime/CrossRampRates";
import PrimeOrderFlowTabs from "src/modules/Prime/PrimeOrderFlowTabs";
import CPGOrderFlow from "src/modules/Transactions/cpg/CPGOrderFlow";
import CPGRates from "src/modules/Transactions/cpg/CPGRates";
import Layout from "./Layout";
import ProtectedRoute from "./ProtectedRoutes";

const AppRouter = () => {
  return (
    <Routes>
      {/* Public Route */}
      <Route path="/login" element={<Login />} />
      <Route path="/verifyOtp" element={<VerifyOtp />} />
      <Route path="/error" element={<GenericError />} />
      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout initialSelectedTab={"prime_order_flow"} />}>
          <Route path="/" element={<PrimeOrderFlowTabs />} />
          <Route path="/download-report" element={<DownloadReport />} />
          <Route path="/cpg" element={<CPGOrderFlow />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/cpg-rates" element={<CPGRates />} />
          <Route path="/cross-ramp-rates" element={<CrossRampRates />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRouter;
